import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const sectionVariants = cva('', {
  variants: {
    tone: {
      inherit: '',
      white: 'bg-white',
      gray50: 'bg-gray-50',
      gray100: 'bg-gray-100',
      charcoal900: 'bg-charcoal-900',
      charcoal800: 'bg-charcoal-800',
    },
    spacing: {
      inherit: '',
      py16: 'py-16',
      py20: 'py-20',
      py24: 'py-24',
      py32: 'py-32',
    },
    border: {
      none: '',
      bGray200: 'border-b border-gray-200',
      bCharcoal700: 'border-b border-charcoal-700',
      bCharcoal800: 'border-b border-charcoal-800',
      yCharcoal800: 'border-y border-charcoal-800',
    },
  },
  defaultVariants: {
    tone: 'inherit',
    spacing: 'inherit',
    border: 'none',
  },
})

type SectionProps = React.ComponentProps<'section'> &
  VariantProps<typeof sectionVariants>

export function Section({
  className,
  tone,
  spacing,
  border,
  ...props
}: SectionProps) {
  return (
    <section
      className={cn(sectionVariants({ tone, spacing, border }), className)}
      {...props}
    />
  )
}
